module.exports = __webpack_public_path__ + "static/media/editpen_white.24b6f032.svg";